<template>
  <v-button class="text-danger text-small icon pointer mr-3" :button="false" :run="run" >
    Reportar erro de IA
  </v-button>
</template>

<script>

import FrontBusiness from "@/business/FrontBusiness";
import ModalJustificarInformacaoErro from "@/views/Odin/componentes/ModalJustificarInformacaoErro.vue";

export default {
  name: 'OdinInformarErro',
  props:{
    referencia: String,
    tipo: String,
  },
  methods:{
    async run(){
      await FrontBusiness.openModal(ModalJustificarInformacaoErro,
        {referencia: this.referencia, tipo: this.tipo});
    }
  }
}
</script>

